import { defineStore } from 'pinia';
import { onRequestDefaultError, requests } from '🔗/utils/requests';

const useUsersApi = defineStore('users-api', {
    state: () => ({
        defaultUserImage: {
            resized: new URL(`🔗/assets/img/users/resized.jpg`, import.meta.url).href,
            original: new URL(`🔗/assets/img/users/original.jpg`, import.meta.url).href
        }
    }),
    actions: {
        async list(params = {}) {
            if (!params.skip) {
                params.skip = 0;
            }

            if (!params.take) {
                params.take = 50;
            }

            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/account/list',
                    params,
                    signal: requests.signal('users')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async getUser(id) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: `/users/${ id }`,
                    signal: requests.signal('user-profile', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async addRole(userId, roleId) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: `/roles/${userId}/${roleId}`,
                    signal: requests.signal('user-role-add', `${ userId }_${ roleId }`)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async removeRole(userId, roleId) {
            try {
                const result = await this.$http({
                    method: 'DELETE',
                    url: `/roles/${userId}/${roleId}`,
                    signal: requests.signal('user-role-remove', `${ userId }_${ roleId }`)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        }
    }
});

export default useUsersApi;
